module.exports = __webpack_public_path__ + "static/ecv-logo-810bdcef69fb2bada3f3cfaac8192664.jpg";